module.exports = __webpack_public_path__ + "img/axironas.d0ebe3d4.jpg";